import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  finished: false,
  error: null,
};

const signupProductorSlice = createSlice({
  name: "authentication/signupProductor",
  initialState,
  reducers: {
    submitSignupProductorInited: {
      prepare: (props) => ({ payload: { props } }),
      reducer: (state) => {
        state.error = null;
        state.finished = false;
        state.loading = true;
      },
    },
    submitSignupProductorCompleted: {
      prepare: () => ({ payload: {} }),
      reducer: (state) => {
        state.loading = false;
        state.finished = true;
      },
    },
    submitSignupProductorFailed: {
      prepare: (error) => ({ payload: { error } }),
      reducer: (state, action) => {
        state.loading = false;
        state.finished = true;
        state.error = { message: action.payload.error };
      },
    },
  },
});

const {
  submitSignupProductorInited,
  submitSignupProductorCompleted,
  submitSignupProductorFailed,
} = signupProductorSlice.actions;

const submitSignupProductor = (data) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(submitSignupProductorInited({ data }));
      await services.api.postSignupProductor(data);
      dispatch(submitSignupProductorCompleted());
    } catch (error) {
      if (error.responseStatus.message)
        dispatch(submitSignupProductorFailed(error.responseStatus.message));
      else dispatch(submitSignupProductorFailed());
    }
  };
};

export default signupProductorSlice.reducer;
export { submitSignupProductor };
